import React from 'react';

const sectionStyle = {
    maxWidth: 600,
    margin: '32px auto',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    padding: '32px 20px',
    fontFamily: 'inherit',
    color: '#222',
};
const h1Style = {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 32,
    letterSpacing: '-1px',
};
const h2Style = {
    fontSize: 20,
    fontWeight: 600,
    margin: '32px 0 12px 0',
    color: '#1a73e8',
};
const articleStyle = {
    fontSize: 16,
    lineHeight: 1.8,
    marginBottom: 18,
};
const strongStyle = { color: '#1a73e8', fontWeight: 600 };

const PrivacyConsent = () => (
    <section style={sectionStyle}>
        <h1 style={h1Style}>개인정보처리동의서</h1>
        <article style={articleStyle}>
            TOBE RICH(이하 '회사'라고 합니다)은(는) 개인정보보호법 등 관련 법령상의 개인정보보호 규정을 준수하며 귀하의 개인정보보호에 최선을 다하고 있습니다. 회사는 개인정보보호법에 근거하여 다음과 같은 내용으로 개인정보를 수집 및 처리하고자 합니다.<br /><br />
            다음의 내용을 자세히 읽어보시고 모든 내용을 이해하신 후에 동의 여부를 결정해주시기 바랍니다.
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제1조 <span style={strongStyle}>(회원 가입을 위한 정보)</span></h2>
            회사는 이용자의 회사 서비스에 대한 회원가입을 위하여 다음과 같은 정보를 수집합니다.<br />
            <span style={strongStyle}>[필수 수집 정보]</span> : 이메일 주소, 비밀번호 및 생년월일
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제2조 <span style={strongStyle}>(회사 서비스 제공을 위한 정보)</span></h2>
            회사는 이용자에게 회사의 서비스를 제공하기 위하여 다음과 같은 정보를 수집합니다.<br />
            <span style={strongStyle}>[필수 수집 정보]</span> : 아이디, 이메일 주소, 이름 및 생년월일
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제3조 <span style={strongStyle}>(서비스 이용 및 부정 이용 확인을 위한 정보)</span></h2>
            회사는 이용자의 서비스 이용에 따른 통계∙분석 및 부정이용의 확인∙분석을 위하여 다음과 같은 정보를 수집합니다. (부정이용이란 회원탈퇴 후 재가입, 상품구매 후 구매취소 등을 반복적으로 행하는 등 회사가 제공하는 할인쿠폰, 이벤트 혜택 등의 경제상 이익을 불·편법적으로 수취하는 행위, 이용약관 등에서 금지하고 있는 행위, 명의도용 등의 불·편법행위 등을 말합니다.)<br />
            <span style={strongStyle}>[필수 수집 정보]</span> : 서비스 이용기록, 접속지 정보 및 기기정보
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제4조 <span style={strongStyle}>(개인정보 보유 및 이용 기간)</span></h2>
            <ol style={{ paddingLeft: 20 }}>
                <li>1. 수집한 개인정보는 수집·이용 동의일로부터 회원탈퇴시까지 보관 및 이용합니다.</li>
                <li>2. 개인정보 보유기간의 경과, 처리목적의 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
            </ol>
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제5조 <span style={strongStyle}>(동의 거부 관리)</span></h2>
            귀하는 본 안내에 따른 개인정보 수집·이용에 대하여 동의를 거부할 권리가 있습니다. 다만, 귀하가 개인정보 동의를 거부하시는 경우에 서비스 이용 중 일부 제한의 불이익이 발생할 수 있음을 알려드립니다.<br /><br />
            본인은 위의 동의서 내용을 충분히 숙지하였으며,위와 같이 개인정보를 수집·이용하는데 동의합니다.
        </article>
        <article style={articleStyle}>
            <h2 style={h2Style}>제6조 <span style={strongStyle}>(개인정보의 제3자 제공)</span></h2>
            회사는 개인정보보호법에 근거하여 다음과 같은 내용으로 개인정보를 제3자에게 제공하고자 합니다.
            <ol style={{ paddingLeft: 20 }}>
                <li>1. 개인정보를 제공 받는 제3자 : Firebase (Google LLC)</li>
                <li>2. 개인정보 제공 목적 : 회원 인증, 데이터 저장 및 알림 발송 등 서비스 운영 목적</li>
                <li>3. 개인정보 제공 항목 : 이메일 주소, 사용자 ID, 기기 정보, 알림 토큰 등</li>
                <li>4. 개인정보 보유 및 이용기간 : 개인정보 제공 목적 달성일까지</li>
                <li>5. 개인정보 제공 거부 시 불이익 : 서비스 이용 중 일부 제한</li>
            </ol>
        </article>
        <div style={{ textAlign: 'right', marginTop: 40, color: '#888', fontSize: 15 }}>
            2025.07.22.
        </div>
    </section>
);

export default PrivacyConsent; 